import { EventEmitter } from '@timing71/common';

// Glue to let SignalR use a ConnectionService

export const createHTTPClient = (connectionService, sessionStickCookie) => ({
  send: async (request) => {
    const reqHeaders = {};
    if (sessionStickCookie) {
      reqHeaders['cookie'] = `stick=${sessionStickCookie}`;
    }
    const response = await connectionService.fetch(
      request.url,
      {
        method: request.method,
        headers: reqHeaders
      }
    );
    return {
      statusCode: 200,
      content: response
    }
  },
  getCookieString: () => sessionStickCookie ? `stick=${sessionStickCookie}` : ''
});

export const createWebsocketConstructor = (connectionService, sessionStickCookie) => {
  class WS extends EventEmitter {
    constructor(url) {
      super();
      const reqHeaders = {};
      if (sessionStickCookie) {
        reqHeaders['Cookie'] = `stick=${sessionStickCookie}`;
      }
      this._socket = connectionService.createWebsocket(url, { headers: reqHeaders });
      this._socket.on('close', this._handleClose.bind(this));
      this._socket.on('open', this._handleOpen.bind(this));
      this._socket.on('message', this._handleMessage.bind(this));
      this._socket.on('error', this._handleError.bind(this));
    }

    _handleClose(...args) {
      this.emit('close', args);
      if (typeof(this.onclose) === 'function') {
        this.onclose(...args);
      }
    }

    _handleOpen(...args) {
      this.emit('open', args);
      if (typeof(this.onopen) === 'function') {
        this.onopen(...args);
      }
    }

    _handleMessage(...args) {
      this.emit('message', args);
      if (typeof(this.onmessage) === 'function') {
        this.onmessage(...args);
      }
    }

    _handleError(...args) {
      this.emit('error', args);
      if (typeof(this.onerror) === 'function') {
        this.onerror(...args);
      }
    }

    send(...args) {
      return this._socket.send(...args);
    }

    close() {
      return this._socket.close()
    }
  }
  return WS;
}
